// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1H1gY","header":"Messages_header__3Ob-O"};